import register from '../../../../global/js/registry';
export default register('o-product-gallery-360', () => import(/* webpackMode: "lazy" */ './o-product-gallery-360.controller'));
